import React from 'react';
import _ from 'lodash';

import PositionedGoodyHOC from '../PositionedGoodyHOC';
import { POSITIONED_GOODY_REFS } from '../../../../constants';

class Cat extends PositionedGoodyHOC {
	// 10
	render() {
		const style = {
			st2: {
				fill: '#FFFFFF',
			},
			st3: {
				fill: '#A5C6EF',
			},
			st11: {
				fill: '#FC7E7E',
			},
		};
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="92.5170654" cy="4.8880091" />
				<path style={style.st2} d="M185.7677765,38.6758385c-0.1119385-1.435009-0.2337799-2.8881111-0.3652344-4.3551292
					c-0.3523102-3.9318104-0.7736664-7.9635563-1.2588348-12.0147591c-0.1005707-0.8397865-0.2038727-1.6804104-0.3098755-2.5211544
					c-0.5310364-4.2116737-3.5700684-7.6716328-7.6672363-8.7822161
					C163.1239624,7.4672256,132.2688293,0.4344695,93.2000732,0.4344695c-39.1307144,0-70.210907,7.0583935-83.2998581,10.5857763
					c-4.0888166,1.1019077-7.1133413,4.5726652-7.6438208,8.7740011c-0.6461701,5.1175919-1.446764,13.1722374-2.0156126,18.9069748
					c-0.3170349,3.1961288,2.7701993,5.6533089,5.8141241,4.6284866l7.1912231-2.4211273
					c0.320797-0.1077385,32.5995941-10.7906799,79.9539413-10.7906799c46.9620514,0,79.3055878,10.678112,79.6022339,10.7776375
					c0,0,3.6892395,1.2011604,7.1979065,2.3298683C182.9946747,44.188694,186.0124359,41.8118973,185.7677765,38.6758385z" />
				<path style={style.st3} d="M1.9424427,22.4024754c-0.2307129,1.9890137-0.4714355,4.2119141-0.7087402,6.479248l1.3132324-0.4428711
					c0.3779297-0.1274414,38.3486328-12.7324228,90.6533203-12.7324228s90.2753906,12.6049814,90.6533203,12.7324228
					l1.0102539,0.3408203c-0.22229-2.1455078-0.4604492-4.3049316-0.7200928-6.4736328v-0.0002441
					c-7.810791-2.3962402-43.6652832-12.5358896-90.9434814-12.5358896C45.2651978,9.769906,9.067687,20.1947117,1.9424427,22.4024754
					z" />
				<path style={style.st11} d="M1.3313587,27.9530125c-0.2280273,2.159668-0.4539795,4.3762188-0.6652832,6.4809551l1.8818359-0.6362305
					c0.3769531-0.1274414,38.2792969-12.73242,90.6523438-12.73242c52.3046875,0,90.2753906,12.6054668,90.6533203,12.7329082
					l1.5489502,0.5224609c-0.1907959-2.128418-0.4053955-4.2885723-0.6357422-6.4628887
					c-6.3265381-1.9816895-42.8981934-12.7290049-91.5665283-12.7290049
					C43.6712036,15.1287928,6.6746202,26.2581882,1.3313587,27.9530125z" />
			</g>
		);
	}
}

class LilDoggo extends PositionedGoodyHOC {
	// 10
	render() {
		const style = {
			st2: {
				fill: '#FFFFFF',
			},
			st3: {
				fill: '#A5C6EF',
			},
			st11: {
				fill: '#FC7E7E',
			},
		};
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="79.5" cy="4.8880091" />
				<path style={style.st2} d="M158.5153046,38.6758385c-0.0953522-1.435009-0.1991425-2.8881111-0.3111115-4.3551292
					c-0.3000946-3.9318104-0.6590118-7.9635563-1.0722656-12.0147591c-0.0856628-0.8397865-0.1736603-1.6804104-0.2639618-2.5211544
					c-0.4523315-4.2116737-3.0409393-7.6716328-6.5308838-8.7822161
					c-11.1096344-3.5353541-37.3918076-10.5681105-70.670311-10.5681105c-33.3312683,0-59.8051605,7.0583935-70.9542389,10.5857763
					c-3.4828262,1.1019077-6.0590954,4.5726652-6.5109539,8.7740011c-0.5504034,5.1175919-1.2323437,13.1722374-1.7168849,18.9069748
					c-0.2700481,3.1961288,2.3596365,5.6533089,4.9524302,4.6284866l6.1254334-2.4211273
					c0.2732534-0.1077385,27.7681084-10.7906799,68.1042099-10.7906799c40.0019455,0,67.5519485,10.678112,67.8046188,10.7776375
					c0,0,3.1424866,1.2011604,6.131134,2.3298683C156.153183,44.188694,158.7236938,41.8118973,158.5153046,38.6758385z" />
				<path style={style.st3} d="M1.9341582,22.4024754c-0.1965196,1.9890137-0.4015656,4.2119141-0.6037,6.479248l1.1186023-0.4428711
					c0.3219178-0.1274414,32.6651001-12.7324228,77.2178726-12.7324228s76.8959503,12.6049814,77.217865,12.7324228
					l0.8605194,0.3408203c-0.1893311-2.1455078-0.3921967-4.3049316-0.6133575-6.4736328v-0.0002441
					C150.478775,19.9095554,119.9381714,9.769906,79.6669312,9.769906C38.8361778,9.769906,8.0033913,20.1947117,1.9341582,22.4024754
					z" />
				<path style={style.st11} d="M1.4136411,27.9530125c-0.1942321,2.159668-0.3866966,4.3762188-0.5666836,6.4809551l1.6029348-0.6362305
					c0.3210859-0.1274414,32.6060371-12.73242,77.217041-12.73242c44.5527649,0,76.8959503,12.6054668,77.217865,12.7329082
					l1.3193817,0.5224609c-0.1625214-2.128418-0.3453064-4.2885723-0.5415192-6.4628887
					c-5.3889008-1.9816895-36.5403824-12.7290049-77.9957275-12.7290049
					C37.4784241,15.1287928,5.9649944,26.2581882,1.4136411,27.9530125z" />
			</g>
		);
	}
}

class TuxedoBird extends PositionedGoodyHOC {
	render() {
		const style = {
			st2: {
				fill: '#FFFFFF',
			},
			st3: {
				fill: '#A5C6EF',
			},
			st11: {
				fill: '#FC7E7E',
			},
		};
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="56.0041687" cy="8.1188641" />
				<path style={style.st2} d="M114.5945511,27.6726074c-0.2905884-2.0812988-0.6337891-3.2333984-0.6337891-3.2333984l-0.7873535-0.3125
					c-0.2321777-0.0922852-23.5791016-9.2075195-55.8395958-9.2075195c-0.0099487,0-0.0196533,0.0002441-0.0296021,0.0002441
					s-0.0196533-0.0002441-0.0296021-0.0002441c-32.260498,0-55.6074219,9.1152344-55.8395996,9.2075195l-0.7873535,0.3125
					c0,0-0.3432007,1.1520996-0.6337891,3.2333984c-0.1953125,2.3112793,1.7063599,4.0883789,3.5813599,3.347168l4.4296269-1.7509766
					c0.1975708-0.0778809,20.0805054-7.8032227,49.2496338-7.8032227c0.0100098,0,0.0197144,0.0002441,0.0297241,0.0002441
					s0.0197144-0.0002441,0.0297241-0.0002441c29.1691246,0,49.0520592,7.7253418,49.24963,7.8032227l4.4296265,1.7509766
					C112.8881912,31.7609863,114.7898636,29.9838867,114.5945511,27.6726074z" />
				<path style={style.st2} d="M108.1357498,11.732666c-2.5525513-3.6206055-6.3862305-6.1191406-10.7012329-7.1220703
					C87.5692215,2.3181152,73.5776443,0,57.3339348,0c-0.0099487,0-0.0197754,0.0002441-0.0297241,0.0002441
					S57.2844353,0,57.2744865,0C41.0307732,0,27.039196,2.3181152,17.1739006,4.6105957
					C12.8588982,5.6135254,9.025219,8.1120605,6.4726672,11.732666c-0.7529297,1.0678711-2.0202637,3.1784668-1.8945312,2.9619141
					c8.3117065-2.65625,27.9640503-7.9436035,52.6964722-7.9436035c0.0099487,0,0.0196533,0.0002441,0.0296021,0.0002441
					s0.0196533-0.0002441,0.0296021-0.0002441c24.7324181,0,44.3847618,5.2873535,52.6964684,7.9436035
					C110.1560135,14.9111328,108.8886795,12.8005371,108.1357498,11.732666z" />
				<path style={style.st3} d="M111.5015335,17.5119629c-0.0650635-0.1369629-0.1283569-0.2773438-0.194397-0.4121094
					c-0.1558838-0.3208008-0.3151245-0.6328125-0.475647-0.9406738c-0.1416016-0.2697754-0.2846069-0.5339355-0.428894-0.7939453
					c-0.1239624-0.2241211-0.246582-0.4541016-0.3723145-0.6706543c-8.3117065-2.65625-27.9640503-7.9436035-52.6964684-7.9436035
					c-0.0099487,0-0.0196533,0.0002441-0.0296021,0.0002441s-0.0196533-0.0002441-0.0296021-0.0002441
					c-24.7324219,0-44.3847656,5.2873535-52.6964722,7.9436035c-0.1257324,0.2165527-0.2483521,0.4465332-0.3723145,0.6706543
					c-0.1442871,0.2600098-0.2872925,0.5241699-0.428894,0.7939453c-0.1605225,0.3078613-0.3197632,0.619873-0.475647,0.9406738
					c-0.06604,0.1347656-0.1293335,0.2751465-0.194397,0.4121094c-0.2745972,0.5825195-0.538147,1.1870117-0.7926636,1.8078613
					c6.4344487-2.2160645,27.5838623-8.6936035,54.9603882-8.6936035c0.0099487,0,0.0196533,0.0002441,0.0296021,0.0002441
					s0.0196533-0.0002441,0.0296021-0.0002441c27.3765221,0,48.5259361,6.4775391,54.9603844,8.6936035
					C112.0396805,18.6989746,111.7761307,18.0944824,111.5015335,17.5119629z" />
				<path style={style.st11} d="M113.2225418,21.8344727c-0.010498-0.0319824-0.0210571-0.0639648-0.0315552-0.0959473
					c-0.194458-0.5930176-0.4143066-1.1542969-0.6323242-1.7177734c-0.069519-0.1796875-0.1298218-0.3708496-0.2014771-0.5473633
					c-0.020813-0.0515137-0.0419922-0.1025391-0.0629883-0.1535645c-6.4344482-2.2160645-27.5838623-8.6936035-54.9603844-8.6936035
					c-0.0099487,0-0.0196533,0.0002441-0.0296021,0.0002441s-0.0196533-0.0002441-0.0296021-0.0002441
					c-27.3765259,0-48.5259399,6.4775391-54.9603882,8.6936035c-0.0209961,0.0510254-0.0421753,0.1020508-0.0629883,0.1535645
					c-0.0716553,0.1765137-0.131958,0.3676758-0.2014771,0.5473633c-0.2180176,0.5634766-0.4378662,1.1247559-0.6323242,1.7177734
					c-0.010498,0.0319824-0.0210571,0.0639648-0.0315552,0.0959473c-0.2727661,0.8395996-0.5214233,1.7070312-0.7382202,2.6047363
					l0.7873535-0.3125c0.2321777-0.0922852,23.5791016-9.2075195,55.8395996-9.2075195
					c0.0099487,0,0.0196533,0.0002441,0.0296021,0.0002441s0.0196533-0.0002441,0.0296021-0.0002441
					c32.2604942,0,55.6074181,9.1152344,55.8395958,9.2075195l0.7873535,0.3125
					C113.7439651,23.5415039,113.4953079,22.6740723,113.2225418,21.8344727z" />
			</g>
		);
	}
}

class Tortoise extends PositionedGoodyHOC {
	render() {
		const style = {
			st2: {
				fill: '#FFFFFF',
			},
			st3: {
				fill: '#A5C6EF',
			},
			st11: {
				fill: '#FC7E7E',
			},
		};
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="30.0382576" cy="13.0568066" />
				<path style={style.st2} d="M50.8361206,0.659043c-3.147686,0.5238518-6.4787979,1.1161793-10.0095253,1.5138811
					C29.9493179,3.39851,20.505518,3.0843146,13.5244579,2.4003196c-2.7943077-0.2737825-5.5940394,0.7394123-7.497828,2.8030744
					C4.5429235,6.8116965,3.2142484,8.646533,2.0455906,10.7100334c-0.5690253,1.0045242-1.0968118,2.0596428-1.5849936,3.1652393
					c-0.9109621,2.063076,0.3581067,4.4352665,2.5788655,4.8281593c7.6437669,1.3523216,24.9448395,2.3591213,39.727562,0.6938572
					c7.1283875-0.803091,15.6455116-2.4009781,20.6940727-3.8030882c2.1795044-0.6053009,3.3574371-2.9666605,1.5785141-5.5859938
					c-1.6478043-2.4262781-3.7933388-5.0259571-5.887455-7.1638966C57.0660973,0.7146722,53.7715874,0.1705091,50.8361206,0.659043z" />
				<path style={style.st3} d="M60.2345543,4.0015373c-5.5842285,1.4033203-11.9116211,2.6464844-18.8162842,3.4243164
					C26.0287457,9.1597404,12.8599215,8.0186272,4.6785254,6.7998772C3.9096043,7.7739983,3.1891453,8.8184319,2.5170262,9.9326897
					c8.1445312,1.3398438,22.4140625,2.8391113,39.2893066,0.9379883c7.7641602-0.8745117,14.8220215-2.329834,20.9328613-3.9482422
					C61.9331627,5.9148674,61.0928307,4.9346428,60.2345543,4.0015373z" />
				<path style={style.st11} d="M1.0031102,12.7217522c7.7030029,1.3947754,22.9091797,3.3137207,41.1535645,1.2585449
					c8.4698486-0.9541016,16.1052246-2.5983887,22.5811806-4.3930664c-0.6855469-0.9838867-1.4390907-1.984375-2.2401161-2.9714355
					c-6.0351562,1.6049805-13.0266113,3.052002-20.729126,3.9196777c-16.9122295,1.9052734-31.1424561,0.3388672-39.0184326-0.9870605
					c-0.2380371,0.3825684-0.4782715,0.762207-0.7045898,1.1616211c-0.3560791,0.628418-0.6899414,1.284668-1.0144043,1.9521484
					C1.0216649,12.6817131,1.0126317,12.7022209,1.0031102,12.7217522z" />
			</g>
		);
	}
}

class Bear extends PositionedGoodyHOC {
	render() {
		const style = {
			st2: {
				fill: '#FFFFFF',
			},
			st3: {
				fill: '#A5C6EF',
			},
			st11: {
				fill: '#FC7E7E',
			},
		};
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="80.0711517" cy="0.5424188" />
				<path style={style.st2} d="M160.1302643,45.7799339c-0.0966034-1.2384224-0.2017517-2.4924583-0.3152008-3.7584991
					c-0.3040466-3.393177-0.6676788-6.8725967-1.08638-10.3688068c-0.086792-0.7247429-0.1759491-1.4502048-0.2674255-2.1757717
					c-0.4582977-3.6346989-3.0809937-6.6206608-6.6168671-7.5791016
					c-11.2558746-3.0510311-37.8840179-9.1203384-71.6005783-9.1203384c-33.7700272,0-60.5924072,6.0914326-71.8882446,9.1355839
					c-3.5286727,0.9509525-6.1388545,3.9462357-6.5966611,7.5720119c-0.5576485,4.4165115-1.2485654,11.3677139-1.739485,16.3168259
					c-0.2736029,2.7582779,2.3906975,4.8788376,5.017622,3.9944115l6.2060661-2.089447
					c0.2768497-0.0929794,28.1336327-9.3124199,69.0007019-9.3124199c40.528511,0,68.4411697,9.215271,68.6971664,9.3011627
					c0,0,3.1838531,1.0366096,6.2118378,2.0106888C157.7370605,50.5375595,160.3414001,48.4863701,160.1302643,45.7799339z" />
				<path style={style.st3} d="M1.4879638,31.7359276c-0.1991066,1.7165298-0.4068515,3.6349068-0.6116468,5.591629l1.133327-0.3822021
					c0.3261554-0.1099815,33.0950851-10.9881516,78.2343292-10.9881516s77.9081726,10.87817,78.2343292,10.9881516
					l0.8718567,0.2941322c-0.1918488-1.8515854-0.3973846-3.7151833-0.6214447-5.5867825v-0.0002117
					C151.9879456,29.5845242,121.0453186,20.83395,80.2439728,20.83395
					C38.8757439,20.83395,7.6370897,29.830616,1.4879638,31.7359276z" />
				<path style={style.st11} d="M0.9605948,36.5260735C0.763806,38.3898773,0.568808,40.3027763,0.3864517,42.119175l1.6240349-0.5490685
					c0.3253129-0.1099854,33.0352478-10.9881535,78.23349-10.9881535c45.1392365,0,77.9081726,10.8785915,78.2343292,10.9885731
					l1.3367462,0.4508858c-0.1646576-1.836834-0.3498535-3.7010612-0.548645-5.5775108
					c-5.4598389-1.7102089-37.0213852-10.9852009-79.0224304-10.9852009
					C37.5001183,25.4587002,5.5718598,35.0634308,0.9605948,36.5260735z" />
			</g>
		);
	}
}

class Leopard extends PositionedGoodyHOC {
	render() {
		const style = {
			st2: {
				fill: '#FFFFFF',
			},
			st3: {
				fill: '#A5C6EF',
			},
			st11: {
				fill: '#FC7E7E',
			},
		};
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="73.5470901" cy="0.2718361" />
				<path style={style.st2} d="M149.0843201,37.5954666c-0.0899506-1.1529922-0.187851-2.3205261-0.293457-3.4992332
					c-0.2830811-3.159111-0.6216278-6.3985176-1.0114441-9.6535549c-0.0808105-0.6747494-0.1638184-1.3501682-0.2489929-2.0256844
					c-0.4266663-3.3839741-2.868454-6.1639614-6.1604156-7.0562878c-10.4794312-2.8405676-35.2707443-8.491209-66.661499-8.491209
					c-31.4405327,0-56.4126816,5.6712403-66.9293213,8.5054016c-3.2852607,0.8853559-5.7153897,3.6740217-6.1416163,7.0496874
					C1.1183941,26.5364418,0.4751374,33.0081444,0.018082,37.6158638c-0.2547295,2.5680046,2.225785,4.5422859,4.6715012,3.7188683
					l5.7779651-1.9453125c0.2577524-0.0865631,26.1929474-8.6700382,64.2409668-8.6700382
					c37.732811,0,63.7200317,8.5795918,63.958374,8.6595554c0,0,2.9642181,0.965107,5.7833405,1.8719902
					C146.8561859,42.0249062,149.2808838,40.1152115,149.0843201,37.5954666z" />
				<path style={style.st3} d="M1.3853225,24.5202332c-0.1853719,1.5981216-0.3787864,3.3841648-0.5694547,5.2059097l1.0551488-0.355835
					c0.3036569-0.102396,30.8121529-10.2301769,72.8376389-10.2301769s72.533989,10.1277809,72.8376389,10.2301769l0.8117218,0.27384
					c-0.1786041-1.7238598-0.3699646-3.4589024-0.5785828-5.2013988v-0.0001965
					c-6.2757721-1.9253178-35.0839462-10.0722685-73.0707779-10.0722685
					C36.1940536,14.3702841,7.1102753,22.7463493,1.3853225,24.5202332z" />
				<path style={style.st11} d="M0.894332,28.979948c-0.1832142,1.735239-0.364761,3.5161839-0.5345381,5.2072849l1.5120075-0.5111961
					c0.3028723-0.1023941,30.7564449-10.2301769,72.836853-10.2301769c42.0254898,0,72.533989,10.1281757,72.8376389,10.2305698
					l1.2445526,0.4197845c-0.1533051-1.7101288-0.3257294-3.4457607-0.5108032-5.1927681
					c-5.0832214-1.5922375-34.4676132-10.2274323-73.5713882-10.2274323
					C34.9133224,18.6760139,5.1875072,27.6182003,0.894332,28.979948z" />
			</g>
		);
	}
}

class Chicken extends PositionedGoodyHOC {
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="34.79963" cy="5.29766" />
				<path fill="#FFFFFF" d="M71.50744,15.72634c-1.55711-3.66364-3.0271-7.32556-4.79568-10.72734
					c-0.7247-1.39392-2.05299-2.37018-3.60104-2.63807C55.82561,1.10024,46.40663,0,35.69302,0
					C25.20889,0,15.92813,1.05405,8.67596,2.28081C6.99987,2.56433,5.5765,3.63927,4.80485,5.15393
					c-1.69139,3.31999-3.16964,6.85548-4.65473,10.42539c-0.61038,1.46726,0.74042,2.83262,2.25078,2.46842
					c6.36888-1.53577,18.24541-3.77869,33.29211-3.77869c15.24835,0,27.28948,2.34164,33.5434,3.87641
					C70.80785,18.5311,72.19926,17.35407,71.50744,15.72634z" />
				<path fill="#A5C6EF" d="M3.57095,7.66504c-0.50049,1.05713-0.98706,2.13013-1.46167,3.21533
					c7.7981-1.67188,19.62573-3.53906,33.58374-3.53906c14.09619,0,26.02441,1.90454,33.81885,3.58887
					c-0.47437-1.08594-0.96118-2.15918-1.46167-3.2168c-7.92432-1.59692-19.21948-3.22583-32.35718-3.22583
					C22.68887,4.48755,11.48354,6.08374,3.57095,7.66504z" />
				<path fill="#FC7E7E" d="M2.27554,10.50708c-0.46729,1.05908-0.92261,2.12988-1.36816,3.21021
					c7.75-1.73218,20.07642-3.7998,34.78564-3.7998c14.84302,0,27.28076,2.11133,35.021,3.85425
					c-0.4458-1.08228-0.90161-2.15552-1.36914-3.2168c-7.96436-1.67651-19.78638-3.49121-33.65186-3.49121
					C21.95791,7.06372,10.23598,8.84399,2.27554,10.50708z" />
			</g>
		);
	}
}

class Bunny extends PositionedGoodyHOC {
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="50.16353" cy="14.63047" />
				<path fill="#FFFFFF" d="M50.27055,19.1013c25.10522,0,42.39575,6.6687,42.55444,6.73096c0,0,1.97217,0.75,3.8479,1.45483
					c1.60083,0.60181,3.21411-0.88257,3.08325-2.84131c-0.00684-0.10254-0.01538-0.2085-0.02246-0.31128
					c-1.64433-5.83488-3.43052-10.93522-5.42618-15.37104c-0.56764-1.26171-1.648-2.20852-2.97896-2.58624
					c-8.16262-2.31655-22.95615-5.61377-41.058-5.61377c-18.07284,0-32.92776,3.28905-41.14816,5.60466
					C7.79145,6.54303,6.70994,7.48708,6.13883,8.74637c-2.04025,4.49879-3.86854,9.68102-5.55529,15.62129
					c-0.00269,0.03027-0.00562,0.06421-0.00806,0.09424c-0.16943,1.99585,1.48096,3.53052,3.10815,2.89062l3.84448-1.51221
					C7.69951,25.77293,24.95537,19.1013,50.27055,19.1013z" />
				<path fill="#A5C6EF" d="M50.27075,6.26043c-21.729,0-38.9375,4.67871-45.99365,6.94312
					c-0.56396,1.45483-1.11279,2.96631-1.646,4.5459c4.04395-1.448,22.81494-7.64844,47.63965-7.64844
					c24.50684,0,43.12452,6.04639,47.4878,7.59399c-0.52686-1.57544-1.06982-3.08276-1.62842-4.53418
					C88.99536,10.88176,71.8689,6.26043,50.27075,6.26043z" />
				<path fill="#FC7E7E" d="M50.27055,9.74022c-23.39551,0-41.55103,5.42407-47.43359,7.41748
					c-0.48535,1.41431-0.95947,2.87842-1.42188,4.39722l0.3938-0.15552c0.20142-0.07959,20.46362-7.95166,48.46167-7.95166
					c27.96167,0,48.26025,7.87256,48.46216,7.95215l0.22681,0.08936c-0.45605-1.51416-0.9248-2.97168-1.40454-4.38159
					C91.51836,15.07445,73.47099,9.74022,50.27055,9.74022z" />
			</g>
		);
	}
}

class Pig extends PositionedGoodyHOC {
	render() {
		return (
			<g>
				<ellipse ref={POSITIONED_GOODY_REFS.MARKER} cx="60" cy="7" />
				<path fill="#FFFFFF" d="M123.64806,21.79376c-1.58815-3.28899-4.60526-5.66306-8.17167-6.45069
					c-0.02039-0.0045-0.04062-0.00896-0.06069-0.01338c-14.12878-3.11115-35.93191-6.66418-61.82241-6.66418
					c-14.72554,0-28.1592,1.14991-39.62077,2.71408c-0.01823,0.00249-0.03662,0.005-0.05518,0.00754
					c-3.36823,0.46144-6.26985,2.60338-7.70163,5.68687c-1.20245,2.58961-2.61784,5.90319-3.67817,9.1882
					c-1.20134,3.72187-1.99692,7.41011-2.48827,10.13201c-0.37718,2.08941,1.46967,3.89668,3.55523,3.49875
					c0.0152-0.0029,0.03027-0.00577,0.04521-0.00861c12.32544-2.34521,29.55042-4.62445,49.94358-4.62445
					c41.44378,0,69.98679,9.56688,70.24857,9.65605l0.00001,0c3.47356,1.07295,6.80466-2.01957,5.98218-5.56081
					c-0.5938-2.55665-1.37199-5.48416-2.35315-8.38378C126.34996,27.65868,124.89671,24.37967,123.64806,21.79376z" />
				<path fill="#A5C6EF" d="M4.43425,21.14037c-0.67529,1.64209-1.33594,3.38452-1.89673,5.12183
					c-0.06763,0.20996-0.12964,0.4187-0.19482,0.62817c13.58765-2.41626,31.22559-4.54224,51.25073-4.54224
					c34.99975,0,62.71045,6.48975,74.21631,9.67871c-0.11304-0.35205-0.21973-0.70361-0.33887-1.05542
					c-0.5835-1.72461-1.25732-3.43726-1.94531-5.05054c-13.4187-3.45557-39.65234-8.89136-71.93213-8.89136
					C34.67595,17.02953,17.8405,18.89843,4.43425,21.14037z" />
				<path fill="#FC7E7E" d="M2.5363,26.26586c-0.62744,1.94482-1.14209,3.87671-1.5625,5.66968
					c13.75488-2.51489,31.89624-4.78613,52.61963-4.78613c36.63501,0,65.28149,7.10938,75.71777,10.10229
					c-0.48633-1.91406-1.06885-3.95679-1.74854-5.99438c-12.67505-3.39551-39.96973-9.42676-73.96924-9.42676
					C33.77044,21.83055,16.23577,23.8828,2.5363,26.26586z" />
			</g>
		);
	}
}

function Sweatband(props) {
	const sweatbands = {
		Cat,
		LilDoggo,
		TuxedoBird,
		Tortoise,
		Bear,
		Leopard,
		Chicken,
		Bunny,
		Pig,
	};

	const ThisSweatband = sweatbands[props.petType.name];

	if (_.isUndefined(ThisSweatband)) {
		return null;
	}

	return <ThisSweatband {...props} />;
}

export default Sweatband;



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Hat/Sweatband.js